var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 689.688 86.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.399;}.a,.b{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.983,
    y1: -0.14,
    x2: 0.983,
    y2: 1.084,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00fddc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-672.5 9.546)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-14891.5-15749.8c39.313,91.772,224.883,22.98,321.523,34.038s281.254,102.3,360.318-10.763v-26.348h-673.455Z",
    transform: "translate(15571.845 15747.517)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-14891.5-15749.8c39.313,91.772,224.883,22.98,321.523,34.038s281.254,102.3,360.318-10.763v-26.348h-673.455Z",
    transform: "translate(15563.999 15744)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHeader);
export default __webpack_public_path__ + "static/media/bg-header.ad7bcecf0025e4ad232fa1d1e9e173d0.svg";
export { ForwardRef as ReactComponent };